/**
 * VersionStamp — a small, persistent, subtle line stamped on every result:
 * "Computed on {result_model_version} · {date}". Renders nothing until the
 * backend attaches the version label, so it's safe to drop onto any result.
 */
interface VersionStampProps {
  /** Curated label the result was produced on (e.g. "v3.12-FRF"). */
  resultModelVersion?: string | null;
  /** ISO date/time the run completed (or was created). */
  date?: string | null;
  className?: string;
}

function fmtDate(raw?: string | null): string | null {
  if (!raw) return null;
  const d = new Date(raw);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function VersionStamp({
  resultModelVersion,
  date,
  className = "",
}: VersionStampProps) {
  if (!resultModelVersion) return null;
  const when = fmtDate(date);
  return (
    <p className={`text-caption text-text-muted ${className}`}>
      Computed on{" "}
      <span className="font-medium text-text-secondary">
        {resultModelVersion}
      </span>
      {when ? ` · ${when}` : ""}
    </p>
  );
}
